export default __webpack_public_path__ + "static/media/aif.1b85feed.svg";